import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { Alert } from "@client/controls/Alert/component";
import { type FormFieldInfo } from "@client/controls/Form/component";
import TextInput from "@client/controls/Inputs/TextInput/component";
import { SystemColor } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormatHtml } from "@common/lib/i18n";
import classnames from "classnames";
import * as React from "react";
import LoginButton from "./Button";

export type MapProps = RootContainerProps & {
  error: string | null;
  status: string;
  canLogin: boolean;
  isAdmin: boolean;
  isDisabled: boolean;
  loginUrl: string | null;
};

export type ActionProps = {};

type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  const fields = React.useMemo(
    (): FormFieldInfo[] => [
      {
        name: "email",
        label: i18n.email,
        isDisabled: !props.canLogin,
        Component: TextInput,
        componentOpts: {
          autoComplete: "email"
        },
        isRequired: true,
        defaultValue: ""
      },
      {
        name: "password",
        label: i18n.password,
        isDisabled: !props.canLogin,
        Component: TextInput,
        componentOpts: { type: "password" },
        defaultValue: ""
      }
    ],
    [props.canLogin, props.isAdmin, props.loginUrl, props.status]
  );

  return (
    <div className={classnames("wsc_login_form", { disabled: props.isDisabled })}>
      {props.isAdmin && (
        <Alert color={SystemColor.Orange}>
          {i18nFormatHtml(i18n.infoStaffLogin, [
            "CLICK_HERE",
            {
              caption: i18n.clickHere,
              className: "text_link",
              keepCase: true,
              onClick: () => window.location.assign(props.loginUrl!)
            }
          ])}
        </Alert>
      )}

      <Form
        {...getRootContainerProps(props)}
        fields={fields}
        Button={LoginButton}
        buttonProps={getRootContainerProps(props)}
        error={props.error ?? undefined}
      />
    </div>
  );
};
